var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem } from "../ComponentRegistry.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import { Component, Schema, type, defaultValue } from "../../decorators/type.js";
import "../types.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let ListenEntityCreationSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "entities");
    __publicField(this, "entity");
  }
};
__decorateClass([
  type(["number"]),
  defaultValue([])
], ListenEntityCreationSchema.prototype, "entities", 2);
__decorateClass([
  type("number"),
  defaultValue(-1)
], ListenEntityCreationSchema.prototype, "entity", 2);
ListenEntityCreationSchema = __decorateClass([
  Component("ListenEntityCreation")
], ListenEntityCreationSchema);
class ListenEntityCreationSystem {
  constructor() {
    __publicField(this, "schema", ListenEntityCreationSchema);
    __publicField(this, "type", "ListenEntityCreation");
    __publicField(this, "category", ComponentCategory.ONKILL);
    __publicField(this, "dependencies", ["Child"]);
  }
  init(entity, gameModel) {
    if (entity !== gameModel.coreEntity) {
      if (!gameModel.hasComponent(gameModel.coreEntity, ListenEntityCreationSchema)) {
        gameModel.addComponent(gameModel.coreEntity, ListenEntityCreationSchema);
      }
      const parentData = gameModel.getTypedUnsafe(gameModel.coreEntity, ListenEntityCreationSchema);
      parentData.entities.push(entity);
    }
  }
  run(entity, gameModel) {
    var _a;
    const data = gameModel.getTypedUnsafe(entity, ListenEntityCreationSchema);
    for (let i = 0; i < data.entities.length; i++) {
      const entityId = data.entities[i];
      if (!gameModel.isActive(entityId)) {
        data.entities.splice(i, 1);
        i--;
        continue;
      }
      const onEntityCreationMods = gameModel.getComponentIdsByCategory(entityId, ComponentCategory.ON_ENTITY_CREATION);
      if (onEntityCreationMods.length) {
        for (let j = 0; j < onEntityCreationMods.length; j++) {
          const mod = gameModel.getComponent(entityId, onEntityCreationMods[j]);
          if ((mod == null ? void 0 : mod.entity) !== void 0) {
            mod.entity = data.entity;
          }
          const system = gameModel.getSystem(mod.type);
          (_a = system.run) == null ? void 0 : _a.call(system, entityId, gameModel);
        }
      }
    }
  }
}
registerSystem(ListenEntityCreationSystem);
export {
  ListenEntityCreationSchema,
  ListenEntityCreationSystem
};
//# sourceMappingURL=ListenEntityCreation.js.map
